import { PageMessageService } from '../../../services/page-message-service';
import { WebApiService } from '../../../services/web-api-service';
import { DefaultValidationRenderer } from "../../../resources/renderers/default-validation-renderer";
import { activationStrategy, Router } from 'aurelia-router';

import { newInstance, autoinject, singleton } from 'aurelia-framework';
import { ValidationRules, ValidationController, ValidationControllerFactory, validateTrigger, Validator } from 'aurelia-validation';
import { DialogService } from 'aurelia-dialog';
import { SimpleDialog } from '../../dialogs/simple-dialog';
import { NewCarrierRequestSearchFormDto, NewCarrierRequestSubmitDto } from './new-carrier-request-dto';
import { SecurityService } from '../../../services/security-service';
import { BusyService } from '../../../services/busy-service';
import { ComposeEmailDialog } from '../../dialogs/compose-email-dialog/compose-email-dialog';
import { RequestDto } from '../../../data/typegen/dtos/request-dto';
import { Globals } from '../../../models/globals';
import { Carrier } from '../../../models/carrier';
import { DisplayValuePair } from '../../../data/typegen/dtos/display-value-pair';
import { SettingsService } from '../../../services/settings-service';

@singleton()
@autoinject()
export class NewCarrierRequest {
    public requestSubmitted: boolean;
    public taskNumber: string;
    public searchDto = new NewCarrierRequestSearchFormDto();
    public entityTypes: { id: string; description: string; }[] = new Globals().getEntityTypes();

    taskId: string;
    private queryParam: string; //json url param specify the search parameters
    public canRequestReevaluation: boolean;
    public canRequestRenewal: boolean;
    public selectedCarrierActiveOnboardingRequest: string;
    public selectedCarrier: any;
    public pageTitle: string;
    selectedCarrierActiveRenewalRequestId: string;
    public requestedForUsers: Array<DisplayValuePair<string>> = [];


    determineActivationStrategy() {
        //activationStrategy.replace to replace the viewmodel with a new instance
        // or activationStrategy.invokeLifecycle to invoke router lifecycle methods on the existing VM
        // or activationStrategy.noChange to explicitly use the default behavior
        return activationStrategy.invokeLifecycle;
    }

    public get isTrucksCarrier(): boolean {
        return this.searchDto && (this.searchDto.entityType == "TRUCKS" || this.searchDto.entityType == 'TRANSLOADER/TRUCKS');
    }

    constructor(
        private dialogService: DialogService,
        private router: Router,
        private busyService: BusyService,
        private settingsService: SettingsService,
        private pageMessageService: PageMessageService,
        private controller: ValidationController,
        private api: WebApiService,
        private securityService: SecurityService) {

        this.controller.validateTrigger = validateTrigger.change;
        controller.addRenderer(new DefaultValidationRenderer());
        this.pageTitle = "Request New Carrier";
    }

    async activate(params) {
        await this.securityService.init();
        this.currentUserIsDivisionUser = this.securityService.user.millCodes.length > 0;
        this.loadCarrierMills();
        this.loadRequestedForUsers();

        this.queryParam = params.query;

        setTimeout(() => { this.fixVerticalTabindex('.page-content'); }, 500);
    }

    private reset() {
        // let user keep old search criteria
        //this.searchDto = new NewCarrierRequestSearchFormDto();
        this.pageMessageService.clear();
        this.dateNeededWarning = "";
        this.pageTitle = "Request New Carrier";
        this.submitDto = new NewCarrierRequestSubmitDto(this.securityService.user.id);
        this.searchResults = [];
        this.requestSubmitted = false;
        this.taskNumber = undefined;
        this.panel1Open = true;
        this.panel2Open = false;
        this.selectedRowId = undefined;
        this.hasSearchCompleted = false;
        this.hasSelectedCarrier = false;
        this.selectedCarrierIsOnMyRoster = false;
        this.selectedCarrier = undefined;
        this.selectedCarrierId = undefined;
        this.canRequestReevaluation = false;
    }

    public currentUserIsDivisionUser = false;
    public searchResults: any = [];
    public panel1Open = true;
    public panel2Open = false;
    public submitDto: NewCarrierRequestSubmitDto = undefined;
    public myDivisions = [];
    public allDivisionsSelected: boolean = false;


    public selectedCarrierId: number;
    public selectedRowId: string;
    public hasSearchCompleted: boolean = false;
    public hasSelectedCarrier: boolean = false;
    public selectedCarrierIsOnMyRoster: boolean = false;


    public attached() {

        setTimeout(() => { this.fixVerticalTabindex('.page-content'); }, 500);

        if (this.queryParam && !this.hasSearchCompleted) {
            Object.assign(this.searchDto, JSON.parse(decodeURIComponent(this.queryParam)));
            this.doSearch();
        }
    }

    fixVerticalTabindex(selector) {
        let tabindex = 1;
        const tables = document.querySelectorAll(selector);

        tables.forEach(tbl => {
            const lastColumns = tbl.querySelectorAll('.row > div[class*="col"]:last-child');

            lastColumns.forEach(col => {
                const formElements = col.querySelectorAll('input, select, textarea');

                formElements.forEach(obj => {
                    obj.setAttribute('tabindex', tabindex++);
                });
            });
        });
    }

    public async doSearch() {
        this.searchResults = [];
        this.hasSearchCompleted = false;
        const v = await this.controller.validate();
        if (v.length == 0) {
            this.busyService.on();
            try {
                var result = await this.api.post("SubmitRequest", "NewCarrierRequest_Search", this.searchDto);
                this.busyService.off();
                this.searchResults = JSON.parse(result.response);
                this.hasSearchCompleted = true;
                this.selectedRowId = undefined;
            } finally {
                this.busyService.off();
                this.updateUrlSearchParams();
            }
        } else {
            //this.router.navigateToRoute("new-carrier-request");
        }
    }

    public async newSearch() {
        this.reset();
    }

    public async updateUrlSearchParams() {
        const json = JSON.stringify(this.searchDto);
        const encodedParam = encodeURIComponent(json);
        this.router.navigateToRoute("new-carrier-request", { query: encodedParam, replace: true });
    }

    public async showSearchStep() {
        this.reset();
    }

    
    public async showRequestEvaluationStep() {
        this.pageTitle = "Request Carrier Re-evaluation";
        this.pageMessageService.clear();
        this.submitDto = new NewCarrierRequestSubmitDto(this.securityService.user.id);
        Object.assign(this.submitDto, this.searchDto);

        
        // for re-evaluation request, overwrite the fields with ones from the actual selected carrier record
        // (character case isn't consistent, so find matching properties using case-insentivive compare)
        for (const prop in this.submitDto) {
            var lowerProp = prop.toLowerCase();
            for (const sourceProp in this.selectedCarrier) {
                if (sourceProp.toLowerCase() == lowerProp) {
                    this.submitDto[prop] = this.selectedCarrier[sourceProp];
                    break;
                }
            }
        }

        this.submitDto.isReevaluationRequest = true;
        this.submitDto.reevaluationRequestCarrierId = this.selectedCarrierId;
        this.requestSubmitted = false;
        this.panel1Open = false;
        this.panel2Open = true;
        setTimeout(() => { this.fixVerticalTabindex('.page-content'); }, 100);
    }

    public async showRequestInsuranceRenewalStep() {
        this.pageTitle = "Request Expedited Insurance Renewal";
        this.pageMessageService.clear();
        this.submitDto = new NewCarrierRequestSubmitDto(this.securityService.user.id);
        Object.assign(this.submitDto, this.searchDto);

        // for re-evaluation request, overwrite the fields with ones from the actual selected carrier record
        // (character case isn't consistent, so find matching properties using case-insentivive compare)
        for (const prop in this.submitDto) {
            var lowerProp = prop.toLowerCase();
            for (const sourceProp in this.selectedCarrier) {
                if (sourceProp.toLowerCase() == lowerProp) {
                    this.submitDto[prop] = this.selectedCarrier[sourceProp];
                    break;
                }
            }
        }

        this.submitDto.isInsuranceRenewalRequest = true;
        this.submitDto.insuranceRenewalRequestCarrierId = this.selectedCarrierId;
        this.requestSubmitted = false;
        this.panel1Open = false;
        this.panel2Open = true;
        setTimeout(() => { this.fixVerticalTabindex('.page-content'); }, 100);
    }



    public async showRequestStep() {
        this.pageMessageService.clear();
        const v = await this.controller.validate();
        if (v.length == 0) {
            //ensure that the DOT # doesn't already exist
            if (this.searchDto.dotNumber && this.searchResults.find(o => o.StatusId != 14 /*Abandoned*/ && !o.Deleted && o.DotNumber == this.searchDto.dotNumber)) {
                this.pageMessageService.setErrorMessage("An active carrier profile already exists for the specified DOT #");
            }
            else {
                this.submitDto = new NewCarrierRequestSubmitDto(this.securityService.user.id);
                this.submitDto.isOnboardingRequest = true;
                Object.assign(this.submitDto, this.searchDto);
                this.requestSubmitted = false;
                this.panel1Open = false;
                this.panel2Open = true;
                setTimeout(() => { this.fixVerticalTabindex('.page-content'); }, 100);
            }
        }
    }

    public dateNeededWarning: string = "";
    public dateNeededChanged() {
        setTimeout(() => {
            const is60DaysOrLessInFuture = (date) => new Date(date) < new Date(Date.now() + 60 * 24 * 60 * 60 * 1000);
            if (this.submitDto.dateNeeded && is60DaysOrLessInFuture(this.submitDto.dateNeeded)) {
                this.dateNeededWarning = "The average time to set up a new carrier is 60 days.";
            } else {
                this.dateNeededWarning = "";
            }
        });
    }


    public async submitRequest(overrideFmcsaNotFound = false) {
        this.pageMessageService.clear();
        const v = await this.controller.validate();
        if (v.length == 0) {
            this.busyService.on();
            try {
                let action = "";
                if (this.submitDto.isReevaluationRequest) {
                    action = "CarrierReevaluationRequest_Submit";
                } else if (this.submitDto.isInsuranceRenewalRequest) {
                    action = "InsuranceRenewalRequest_Submit";
                } else {
                    action = "NewCarrierRequest_Submit";
                }

                this.submitDto.overrideFmcsaNotFound = overrideFmcsaNotFound;
                var result = await this.api.post("SubmitRequest", action, this.submitDto);

                // check for possibility that DOT # doesn't exist in FMCSA API search
                var responseCode = result.headers.get("x-cmp-response-code");
                if (responseCode == "FMCSA-NOT-FOUND") {
                    debugger;
                    if (this.settingsService.settings["allowOverrideFmcsaNotFound"] == true) {
                        // if system allows, allow user opportunity to create the request, even if not found in FMCSA api search
                        this.dialogService.open({
                            viewModel: SimpleDialog,
                            model: {
                                title: "FMCSA Validation Failed",
                                icon: "fa-exclamation-triangle",
                                message: "DOT # not found in FMCSA database.  Do you still want to create a request for this carrier?",
                                buttons: ["Yes", "No"]
                            }
                        }).whenClosed((result) => {
                            if (!result.wasCancelled) {
                                if (result.output == "Yes") {
                                    this.submitRequest(true);
                                }
                            }
                        });
                    } else {
                        // otherwise, prohibit the user from submitting the request.
                        this.dialogService.open({
                            viewModel: SimpleDialog,
                            model: {
                                title: "FMCSA Validation Failed",
                                icon: "fa-exclamation-triangle",
                                message: "DOT # not found in FMCSA database.  Please update the information and try again.",
                                buttons: ["Ok"]
                            }
                        });
                    }
                } else {
                    var req = JSON.parse(result.response) as RequestDto;
                    this.taskNumber = req.number;
                    this.taskId = req.taskId;
                    this.requestSubmitted = true;
                }
            } finally {
                this.busyService.off();
            }
        }
    }

    public onRowDoubleClick(args) {
        var carrierId = args.data.Id;
        this.viewCarrierDetails(carrierId);
    }

    public viewCarrierDetails(carrierId) {
        this.pageMessageService.clear();
        if (this.currentUserIsDivisionUser) {
            this.router.navigate(`carrier-summary/${carrierId}`);
        } else {
            this.router.navigate(`work-carrier/${carrierId}`);
        }
    }

    public async onRowSelected(args) {
        if (this.securityService.user) {
            if (args.node.selected) {
                this.hasSelectedCarrier = true;
                this.selectedRowId = args.node.id;
                this.selectedCarrier = args.data;
                this.selectedCarrierId = this.selectedCarrier.Id;
                const carrierMills = (this.selectedCarrier.Mills || "");
                const myMills = this.securityService.user.millCodes;
                let selectedCarrierIsOnMyRoster = false;
                myMills.forEach(o => {
                    if (carrierMills.indexOf(o) > -1) {
                        selectedCarrierIsOnMyRoster = true;
                    }
                });
                this.selectedCarrierIsOnMyRoster = selectedCarrierIsOnMyRoster;


                this.selectedCarrierActiveOnboardingRequest = undefined;
                this.selectedCarrierActiveRenewalRequestId = undefined;
                let request: RequestDto;
                this.busyService.on();
                try {
                    const result = await this.api.get("Carriers", "GetCarrierRequest", { carrierId: this.selectedCarrierId, includeClosed: false });
                    request = JSON.parse(result.response || null);
                    if (request && request.active) {
                        if (request.type.value == "2c837aa3-48a5-4a66-8a9f-a70d04d0a8b8") {
                            this.selectedCarrierActiveOnboardingRequest = request.number;
                        } else if (request.type.value == "c905cd38-ff01-4e0c-84cc-87bd9b9e52d2") {
                            this.selectedCarrierActiveRenewalRequestId = request.requestId;
                        }
                    }
                } finally {
                    this.busyService.off();
                }



                this.canRequestReevaluation = false;
                this.canRequestRenewal = false;
                // if there's no active request, then we can allow a re-evaluation
                if (!this.selectedCarrierActiveOnboardingRequest) {

                    // determine canRequestReevaluation flag
                    const allowedReevaluationStatusIds = [
                        9, //	Not Qualified
                        10, //	Inactive
                        11, //	Master Approved - Dormant
                        13, //	Suspended
                        12, //	Closed - Incomplete
                    ];
                    if (allowedReevaluationStatusIds.indexOf(this.selectedCarrier.StatusId) > -1) {
                        this.canRequestReevaluation = true;
                    }

                    // allow renewal if master approved
                    this.canRequestRenewal = this.selectedCarrier.StatusId == 8;
                }

            } else {
                // can't unselect current row, but this fired when the previous row is unselected
            }
        }
    }


    loadCarrierMills() {
        if (this.myDivisions.length == 0) {
            this.busyService.on();
            return this.api.get("Divisions", "GetDivisions")
                .then((result) => {
                    let carrierMills = JSON.parse(result.response);
                    this.myDivisions = carrierMills.filter((item) =>
                        this.securityService.user.millCodes.length == 0
                        || this.securityService.user.millCodes.find(myMillCode => myMillCode == item.code)
                    );
                    this.busyService.off();
                });
        }
    }

    private loadRequestedForUsers() {
        this.busyService.on();
        return this.api.get("Tasks", "GetRequestedForUsers")
            .then((result) => {
                this.requestedForUsers = JSON.parse(result.response);
                this.busyService.off();
            });

    }
}